import styled, { css } from 'styled-components'

export const StarList = styled.ul`
  ${({ disabled }) => css`
    display: flex;
    flex-direction: row;
    gap: 38px;

    li {
      cursor: ${disabled ? 'not-allowed' : 'pointer'};
    }
  `}
`
